(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      if (typeof ResizeObserver !== 'undefined') {
        this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerResizeObserver.observe(this.header);
      }

      window.matchMedia('(max-width: 989px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      if (Number.isFinite(this.headerBounds.top)) {
        this.headerBounds = { top: this.headerBounds.top, bottom: this.headerBounds.top + height };
      }
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pjs-cart-value"] && !Shopify.designMode) return;
  try {
    
  if (!window.PjsCartPageSync) {
    window.PjsCartPageSync = {
      unsubscribe: null,
      startFrame: null,
      controller: null,
      sequence: 0,

      start() {
        if (this.unsubscribe) return;

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
          this.startFrame = requestAnimationFrame(() => this.start());
          return;
        }

        if (this.startFrame) cancelAnimationFrame(this.startFrame);

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.sync(event.source).catch((error) => this.handleError(error));
        });
      },

      async sync(source) {
        const includeFooter = source !== 'cart-items';
        const currentSequence = this.sequence + 1;
        this.sequence = currentSequence;

        if (this.controller) this.controller.abort();
        this.controller = new AbortController();

        const checkoutButton = document.getElementById('checkout');
        if (includeFooter && checkoutButton) {
          checkoutButton.disabled = true;
          checkoutButton.setAttribute('aria-disabled', 'true');
        }

        const targets = [
          {
            element: document.querySelector('.pjs-cart-value[data-id]'),
            selector: '.pjs-cart-value[data-id]',
            childSelector: null,
          },
          {
            element: document.querySelector('.pjs-cart-assurance[data-id]'),
            selector: '.pjs-cart-assurance[data-id]',
            childSelector: null,
          },
        ];

        if (includeFooter) {
          const footer = document.querySelector('#main-cart-footer[data-id]');
          targets.push({
            element: footer ? footer.querySelector('.js-contents') : null,
            selector: '#main-cart-footer[data-id]',
            childSelector: '.js-contents',
            sectionId: footer ? footer.dataset.id : null,
          });
        }

        const connectedTargets = targets
          .filter((target) => target.element)
          .map((target) => ({
            ...target,
            sectionId: target.sectionId || target.element.dataset.id,
          }))
          .filter((target) => target.sectionId);

        if (connectedTargets.length === 0) return;

        const sectionIds = [...new Set(connectedTargets.map((target) => target.sectionId))];
        const requestUrl = new URL(window.routes.cart_url, window.location.origin);
        requestUrl.searchParams.set('sections', sectionIds.join(','));

        const response = await fetch(requestUrl.toString(), {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          signal: this.controller.signal,
        });

        if (!response.ok) throw new Error(`Cart section refresh failed: ${response.status}`);

        const sections = await response.json();
        if (currentSequence !== this.sequence) return;

        let sourceFooter = null;
        const replacements = connectedTargets.map((target) => {
          const markup = sections[target.sectionId];
          if (typeof markup !== 'string') throw new Error(`Cart section missing: ${target.sectionId}`);

          const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
          const sourceElement = Array.from(documentFragment.querySelectorAll(target.selector)).find(
            (element) => element.dataset.id === target.sectionId
          );

          if (!sourceElement) throw new Error(`Cart section target missing: ${target.sectionId}`);

          if (target.childSelector) sourceFooter = sourceElement;
          const replacement = target.childSelector ? sourceElement.querySelector(target.childSelector) : sourceElement;
          if (!replacement) throw new Error(`Cart section content missing: ${target.sectionId}`);

          return {
            current: target.element,
            replacement,
          };
        });

        if (currentSequence !== this.sequence) return;

        replacements.forEach(({ current, replacement }) => {
          if (current.isConnected) current.replaceWith(replacement);
        });

        if (sourceFooter) {
          const currentFooter = document.querySelector('#main-cart-footer[data-id]');
          const currentCheckout = currentFooter ? currentFooter.querySelector('#checkout') : null;
          const sourceCheckout = sourceFooter.querySelector('#checkout');

          if (currentFooter) currentFooter.classList.toggle('is-empty', sourceFooter.classList.contains('is-empty'));
          if (currentCheckout) {
            currentCheckout.disabled = !sourceCheckout || sourceCheckout.disabled;
            if (currentCheckout.disabled) {
              currentCheckout.setAttribute('aria-disabled', 'true');
            } else {
              currentCheckout.removeAttribute('aria-disabled');
            }
          }
        }

        if (includeFooter) {
          const cartUi = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const cartLink = document.getElementById('cart-icon-bubble');
          if (cartUi && cartLink && typeof cartUi.setActiveElement === 'function') {
            cartUi.setActiveElement(cartLink);
          }
        }
      },

      handleError(error) {
        if (error.name === 'AbortError') return;
        console.error(error);
        window.location.reload();
      },
    };

    window.PjsCartPageSync.start();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pjs-winter-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.wh-mobile-menu-panel a').forEach((link) => {
  link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
});

  } catch(e) { console.error(e); }
})();
})();
